import {styled} from '@mui/material/styles'
import {Box} from '@mui/material'

export const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  position: 'relative'
}))

export const MapDivStyles = styled('div', {shouldForwardProp: (prop) => prop !== 'applyZIndex'})(({applyZIndex}) => ({
  position: 'absolute',
  padding: '10px',
  cursor: 'default',
  zIndex: applyZIndex && 10,
  width: '140px'
}))

export const StyledButton = styled('button')(({theme}) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  cursor: 'pointer',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: theme.palette.hpWhite,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.hpWhite}`,
  boxShadow: theme.shadows[4],
  ':hover': {
    backgroundColor: theme.palette.grey[100]
  }
}))

export const StyledBox = styled(Box)(({theme}) => ({
  position: 'absolute',
  padding: '10px',
  zIndex: 2,
  bottom: '92px',
  left: '74px',
  [theme.breakpoints.xl]: {
    left: '0px'
  },
  [theme.breakpoints.up('xl')]: {
    left: '0px'
  },
  [theme.breakpoints.between(1526, 1628)]: {
    left: '74px'
  }
}))

export const StyledFocusDiv = styled('div')(({theme}) => ({
  position: 'absolute',
  top: '70px',
  left: '20px'
}))
export const Overlay = styled('div')(({theme}) => ({
  position: 'absolute',
  inset: 0,
  backgroundColor: theme.palette.hpBaseLighter,
  opacity: 0.6,
  borderRadius: 8,
  zIndex: 1,
  pointerEvents: 'auto'
}))

export const ChartBlankErrorWrapper = styled('div')({
  position: 'absolute',
  top: 8,
  left: 8,
  right: 8,
  zIndex: 2,
  pointerEvents: 'none'
})

export const RootContainer = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%'
})
